const MARKET_YOY_GROWTH_EXPECTATION_NAMESPACE = 'jbp-market-yoy-growth-expectation'

export const MARKET_YOY_GROWTH_EXPECTATION_TRANSLATION_KEYS = {
  title: `${MARKET_YOY_GROWTH_EXPECTATION_NAMESPACE}-title`,
  subtitle: `${MARKET_YOY_GROWTH_EXPECTATION_NAMESPACE}-subtitle`,
  empty: `${MARKET_YOY_GROWTH_EXPECTATION_NAMESPACE}-empty`,
  notAllowed: `${MARKET_YOY_GROWTH_EXPECTATION_NAMESPACE}-not-allowed`,
  save: `${MARKET_YOY_GROWTH_EXPECTATION_NAMESPACE}-save`,
  cancel: `${MARKET_YOY_GROWTH_EXPECTATION_NAMESPACE}-cancel`,
  publish: `${MARKET_YOY_GROWTH_EXPECTATION_NAMESPACE}-publish`,
  unlock: `${MARKET_YOY_GROWTH_EXPECTATION_NAMESPACE}-unlock`,
  export: `${MARKET_YOY_GROWTH_EXPECTATION_NAMESPACE}-export`,
  banner: {
    published: `${MARKET_YOY_GROWTH_EXPECTATION_NAMESPACE}-banner-published`,
    locked: `${MARKET_YOY_GROWTH_EXPECTATION_NAMESPACE}-banner-locked`,
  },
  table: {
    offering: `${MARKET_YOY_GROWTH_EXPECTATION_NAMESPACE}-table-offering`,
    yoyGrowth: `${MARKET_YOY_GROWTH_EXPECTATION_NAMESPACE}-table-yoy-growth`,
    sobYoyGrowth: `${MARKET_YOY_GROWTH_EXPECTATION_NAMESPACE}-table-sob-yoy-growth`,
    worldwide: `${MARKET_YOY_GROWTH_EXPECTATION_NAMESPACE}-table-worldwide`,
    toWorldwide: `${MARKET_YOY_GROWTH_EXPECTATION_NAMESPACE}-table-to-worldwide`,
  },
  log: {
    title: `${MARKET_YOY_GROWTH_EXPECTATION_NAMESPACE}-log-title`,
    timestamp: `${MARKET_YOY_GROWTH_EXPECTATION_NAMESPACE}-log-timestamp`,
    user: `${MARKET_YOY_GROWTH_EXPECTATION_NAMESPACE}-log-user`,
    event: `${MARKET_YOY_GROWTH_EXPECTATION_NAMESPACE}-log-event`,
    change: `${MARKET_YOY_GROWTH_EXPECTATION_NAMESPACE}-log-change`,
    rtm: `${MARKET_YOY_GROWTH_EXPECTATION_NAMESPACE}-log-rtm`,
    metric: `${MARKET_YOY_GROWTH_EXPECTATION_NAMESPACE}-log-metric`,
    market: `${MARKET_YOY_GROWTH_EXPECTATION_NAMESPACE}-log-market`,
    category: `${MARKET_YOY_GROWTH_EXPECTATION_NAMESPACE}-log-category`,
  },
}
